import {createSlice, PayloadAction, createAsyncThunk} from "@reduxjs/toolkit";
import * as T from "utils/types";
import * as API from 'app/public_api';

export const cntPerPage = 10;

const initList = createAsyncThunk(
    'profilePg/ScopusTab/initList', 
    async (
        data:{
            randomID: string,
            year: number,
            sortType: T.pubListSortType
        }, 
        thunkAPI
    )=>{
        const {
            year, sortType, randomID
        } = data;
        const {currentPage}= (thunkAPI.getState() as T.RootState).profilePg_scopusTab;
        return await API.rPubList_oneRsr(
            randomID,
            currentPage+1,
            year,
            sortType
        );
    }
)
const loadMore = createAsyncThunk(
    'profilePg/ScopusTab/rPubList', 
    async ( data:{randomID: string}, thunkAPI
    )=>{
        const {
            yearFilter: {year},
            sortType,
            currentPage
        }= (thunkAPI.getState() as T.RootState).profilePg_scopusTab;
        return await API.rPubList_oneRsr(
            data.randomID,
            currentPage+1,
            year,
            sortType
        );
    }
)

const rPubYearStat = createAsyncThunk(
    'pubTab/rPubYearStat', 
    async (data:{
        randomID: string, 
    }, thunkAPI)=>{
        return await API.rPubYearStat_oneRsr(
            data.randomID,
        );
    }
)

export const profilePg_scopusTab_Thunks = {initList, loadMore, rPubYearStat};

export const initialState: T.ProfilePg_ScopusTab = {
    total: -1,
    pubList: [],
    currentPage: 0,
    hasNext: true,
    status: 'idle',
    errorMsg: null,
    yearFilter: {
        total: -1,
        year: -1,
        years: [],
        status: 'idle',
        errorMsg: null,
    },
    sortType: "-date"
}

// profilePg_scopusTab_S
export default createSlice({
    name: 'profilePg/ScopusTab',
    initialState,
    reducers: {
        setSortType: (state, action: PayloadAction<T.pubListSortType>) => {
            state.sortType = action.payload;
        },
        setYear: (state, action: PayloadAction<number>) => {
            state.yearFilter.year = action.payload;
        },
    },
    extraReducers: builder=>{

        // initList thunk (this maybe called by other component, so it has this init steps)
        builder.addCase(initList.pending, (state, action) => {

            state.currentPage = initialState.currentPage;
            state.errorMsg = initialState.errorMsg;
            state.hasNext = initialState.hasNext;
            state.status = 'loading';

            // set the list to be cntPerPage skeleton items
            state.pubList = [
                ...new Array(cntPerPage)
            ].map(()=>({loading: true, item: null}));
        });
        builder.addCase(initList.fulfilled, (state, action) => {
            state.status = 'succeeded';

            const {links, total_result, results} = action.payload            

            state.total = total_result;
            state.hasNext = !!links.next;
            state.currentPage += 1;

            // set the list to what we received
            state.pubList = results.map(
                x=>({loading:false, item: x})
            );
        });
        builder.addCase(initList.rejected, (state, action) => {
            state.status = 'failed';
            state.errorMsg = action.error.message;
        });

        // loadMore thunk
        builder.addCase(loadMore.pending, (state, action) => {
            state.status = 'loading';

            // add cntPerPage skeleton items to the list
            state.pubList = state.pubList.concat( 
                [...new Array(cntPerPage)].map(()=>({loading:true, item: null}))
            );
        });
        builder.addCase(loadMore.fulfilled, (state, action) => {
            state.status = 'succeeded';

            const {links, total_result, results} = action.payload            

            state.total = total_result;
            state.hasNext = !!links.next;
            state.currentPage += 1;

            // replace the last cntPerPage skeleton item list 
            // to the list we received
            state.pubList = state.pubList.slice(0, -cntPerPage).concat( 
                results.map(x=>({loading:false, item: x}))
            );
        });
        builder.addCase(loadMore.rejected, (state, action) => {
            state.status = 'failed';
            state.errorMsg = action.error.message;
        });

        // Year stat thunk
        builder.addCase(rPubYearStat.pending, (state, action) => {
            state.yearFilter.status = 'loading';
        });
        builder.addCase(rPubYearStat.fulfilled, (state, action) => {
            state.yearFilter.status = 'succeeded';

            const {total, years} = action.payload;

            state.yearFilter.years = years;
            state.yearFilter.total = total;
        });
        builder.addCase(rPubYearStat.rejected, (state, action) => {
            state.yearFilter.status = 'failed';
            state.yearFilter.errorMsg = action.error.message;
        });
    }
});
